import { CoreImpl } from '@inter-ikea-core/core';
export const getSceneManager = (sceneManagerOrCoreImpl) => {
    if (sceneManagerOrCoreImpl instanceof CoreImpl) {
        const coreImpl = sceneManagerOrCoreImpl;
        return coreImpl.services.sceneManager;
    }
    else {
        const sceneManager = sceneManagerOrCoreImpl;
        return sceneManager;
    }
};
export const getSceneEntities = (sceneManagerOrCoreImpl) => {
    return getSceneManager(sceneManagerOrCoreImpl).entities;
};
//# sourceMappingURL=get-scene-manager.js.map